import React, { useEffect, useState } from "react";
import axios from "axios";
import StageViewAccordionList from "./StageViewAccordionList";
import { RecruitingHistoryContent } from "../CandidatesTabsContent/CandidateRecruitingHistory";
import { RECORDS_CHANGED } from "../../utils/recordChanges";
import { pipelineStageKey, RECRUITING_STAGES } from "../../utils/pipelineStages";

export default function RecruitingStageAccordionList({ candidateId, candidates = [], jobId, refreshKey, stages = [], ...props }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);
  const candidateKey = JSON.stringify(candidateId ? [[String(candidateId), ""]] :
    [...new Map(candidates.filter(row => row.candidateId || row.candidate_id).map(row =>
      [String(row.candidateId || row.candidate_id), row.name || row.candidate_name || row.full_name || "Candidate"]))].sort());

  useEffect(() => {
    let active = true, requestId = 0;
    const load = async () => {
      const id = ++requestId;
      setLoading(true);
      setHistory([]);
      try {
        const token = ["token", "authToken", "jwt", "accessToken"].map(key => localStorage.getItem(key)).find(Boolean);
        const base = (process.env.REACT_APP_API_BASE || "").trim().replace(/\/$/, "");
        const entries = [];
        const people = JSON.parse(candidateKey);
        for (let start = 0; start < people.length; start += 4) {
          if (!active || id !== requestId) return;
          const batches = await Promise.all(people.slice(start, start + 4).map(async ([personId, name]) => {
            const { data } = await axios.get(`${base}/candidate-stages/${encodeURIComponent(personId)}/history`, {
              withCredentials: true,
              headers: token ? { Authorization: `Bearer ${token}`, "x-access-token": token } : {},
            });
            return (data.history || []).filter(entry => !jobId || String(entry.job_id) === String(jobId))
              .map(entry => ({ ...entry, id: `${personId}:${entry.id}`, candidate_name: name }));
          }));
          entries.push(...batches.flat());
        }
        entries.sort((a, b) => new Date(a.occurred_at || 0) - new Date(b.occurred_at || 0) || String(a.id).localeCompare(String(b.id), undefined, { numeric: true }));
        if (active && id === requestId) { setHistory(entries); setError(""); }
      } catch {
        if (active && id === requestId) setError("Unable to load recruiting history.");
      } finally {
        if (active && id === requestId) setLoading(false);
      }
    };
    load();
    window.addEventListener(RECORDS_CHANGED, load);
    return () => { active = false; window.removeEventListener(RECORDS_CHANGED, load); };
  }, [candidateKey, jobId, refreshKey, retry]);

  const combinedStages = [...stages];
  for (const entry of history) {
    if (!combinedStages.some(stage => pipelineStageKey(stage.key) === pipelineStageKey(entry.stage))) {
      combinedStages.push({ key: entry.stage, items: [] });
    }
  }
  const order = RECRUITING_STAGES.map(stage => stage.id);
  combinedStages.sort((a, b) => order.indexOf(pipelineStageKey(a.key)) - order.indexOf(pipelineStageKey(b.key)));
  return <StageViewAccordionList {...props} stages={combinedStages}
    renderHistory={stage => <RecruitingHistoryContent history={history} stage={stage} loading={loading}
      error={error} onRetry={() => setRetry(value => value + 1)} showCandidate={!candidateId} />} />;
}
